<form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-form-title [editMode]="productStatus() !== undefined" model="Product Status"></app-form-title>

	<app-product-dropdown-field
		[fg]="form"
		formGroupOrControlName="product_name"
		label="Product Name"
	></app-product-dropdown-field>

	<app-text-field [fg]="form" formGroupOrControlName="status" label="Status"></app-text-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
		<button nz-button type="button" (click)="clear()">Clear</button>
	</div>
</form>
